import { useState } from 'react'

import { useLinkPreview } from '../hooks/useLinkPreview'

// Mounted with the url as its key, so a new link starts from nothing.
export const LinkPreviewCard = ({ url }: { url: string }) => {
  const preview = useLinkPreview(url)
  const [imageFailed, setImageFailed] = useState(false)

  if (!preview) return null

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      className="mt-2 flex gap-2.5 rounded-xl border border-current/20 bg-current/5 p-2.5 transition-colors hover:border-current/40"
    >
      {preview.image && !imageFailed && (
        <img
          src={preview.image}
          alt=""
          loading="lazy"
          referrerPolicy="no-referrer"
          onError={() => setImageFailed(true)}
          className="h-14 w-14 shrink-0 rounded-lg object-cover"
        />
      )}
      <span className="min-w-0">
        <span className="block text-xs opacity-70">{preview.host}</span>
        <span className="mt-0.5 line-clamp-2 block break-words font-medium">
          {preview.title}
        </span>
        {preview.description && (
          <span className="mt-1 line-clamp-2 block text-xs opacity-80">
            {preview.description}
          </span>
        )}
      </span>
    </a>
  )
}
